import React, { Component } from 'react'
import { Form, Select } from 'antd'
import { SexProvider, SexConsumer } from '../../../../context/SexContext'

export default class MappingSexForm extends Component {
  render() {
    return (
      <SexProvider>
        <SexConsumer>
          {({ fetching, sexs, requestSexList }) => {
            if (!fetching && !sexs) {
              setTimeout(() => {
                requestSexList({
                  options: {
                    limit: 9999
                  }
                })
              }, 50)
            }

            const sexsOptions = sexs?.map(sex => {
              return {
                label: sex.name,
                value: sex.key
              }
            }) as any

            return (
              <Form.Item
                label="Sex"
                name="sex_key"
                rules={[
                  {
                    required: true,
                    message: 'Missing an sex'
                  }
                ]}
              >
                <Select
                  loading={fetching}
                  placeholder="Select an sex"
                  options={sexsOptions}
                />
              </Form.Item>
            )
          }}
        </SexConsumer>
      </SexProvider>
    )
  }
}
